<template>
    <header :class="{ mini: true }">
      <div @click="toggleMenu" class="action-wrapper">
        <span v-if="!isMenuOpen">
          <img v-svg-inline :src="hamburgerIcon" alt="svg image"/>
        </span>
        <span v-else class="close-icon">
          <img v-svg-inline :src="closeIcon" alt="svg image" />
        </span>
      </div>
      <div class="logo-wrapper">
        <div class="logo" v-if="imageType === 'svg'" @click="goToHome">
          <div v-html="logo"> </div>
        </div>
        <img v-else-if="imageType === 'others'" @click="goToHome" :src="logo" alt=" image" class="logo" />
      </div>
   
      <nav>
        <div class="sidebar-wrapper" :class="{ 'open': isMenuOpen }">
            <!-- First Column: Menu Links -->
            <div class="sidebar">
              <ul class="menu-top">
                <router-link 
                  v-for="({ disable, event, href, path, target, icon, iconActive, label, dropdown, iconDown }, index) in header" :key="index"
                  :to="path"
                  v-slot="{ href, navigate, isActive }"
                  class="link"
                  :active="isActive"
                  :href="href"
                  @click="navigate"
                >
                  <li v-if="!disable" :id="`nav-item-${index}`" :class="[{ 'active': activeIndex === index}, label]" :title="label" >
                    <template v-if="event">
                      <a @click="$emit(event)" :target="target">
                        <img v-svg-inline :src="icon" alt="svg image" />
                        <span>{{ label }}</span>
                      </a>
                    </template>
                    <template v-else-if="dropdown && dropdown.length > 0">
                      <div @click="toggleManageDropdown()">
                        <span v-if="activeIndex === index && iconActive" class="active-icon">
                          <img v-svg-inline :src="iconActive" alt="svg image" />
                        </span>
                        <span v-else class="menu-item-svg">
                          <img v-svg-inline :src="icon" alt="svg image" />
                        </span>
                        <span >{{ label }} </span>
                      </div>
                      <img v-svg-inline :src="arrowRightIcon" alt="svg image" />
                    </template>
                    <template v-else-if="label === HEADERS.EFNA || label === HEADERS.REPORT">
                      <div @click="openSubMenus(label)">
                        <span v-if="activeIndex === index && iconActive" class="active-icon">
                          <img v-svg-inline :src="iconActive" alt="svg image" />
                        </span>
                        <span v-else class="menu-item-svg">
                          <img v-svg-inline :src="icon" alt="svg image" />
                        </span>
                        <span >{{ label }} </span>
                      </div>
                      <img v-svg-inline :src="arrowRightIcon" alt="svg image" />
                    </template>
                    <template v-else >
                      <div @click="handleLinkClick(index)">
                        <span v-if="activeIndex === index && iconActive" class="active-icon">
                          <img v-svg-inline :src="iconActive" alt="svg image" />
                        </span>
                        <span v-else class="menu-item-svg">
                          <img v-svg-inline :src="icon" alt="svg image" />
                        </span>
                        <span >{{ label }} </span>
                      </div>
                    </template>
                  </li>
                </router-link>
              </ul>

              <ul class="menu-bottom ">
                <li v-for="(item, i) of profileOptions" :key="i" >
                  <a :class="item.label" :href="item.href ? item.href : undefined" @click="handleEvent(item.event)">
                    <img id="profile" v-if="item.icon" v-svg-inline :src="item.icon"
                      alt="svg image" />
                    <span>{{ item.label }}</span>
                  </a>
                </li>
              </ul>
              
              <div class="user-detail">
                {{ this.currentUser.userPersonalInfo?.fullname }}
              </div>
            </div>

            <!-- Submenus -->
            <div class="submenu-wrapper" @click="handleEmptyAreaClick()">
              <!-- Submenu Column 1 -->
              <div class="submenu" :class="{ 'open': isEfnaMenuOpen }">
                <ul>
                  <li v-for="(item, i) of userAccessViews" :key="i" :class="{'hide': item.shouldHide}" @click="handleEfnaRoute(item.href)" >{{ item.label }}</li>
                </ul>
              </div>

              <div class="submenu" :class="{ 'open': isReportMenuOpen}">
                <ul>
                  <li v-for="(item, i) of reportOptions" :key="i" :class="{'hide': item.shouldHide}" @click="handleRoute(item.href)" >{{ item.label }}</li>
                </ul>
              </div>

              <div class="submenu" :class="{ 'open': isManageMenuOpen }">
                <ul>
                 <template v-for="(menu, index) in slicedItems">
                    <router-link v-if="!menu.disable" :key="index" :to="menu.url">
                      <li v-if="!menu.disable" :key="index" class="link" :class="{ 'selected-menu': currentRoute.startsWith(menu.url) }" @click="handleSubLinkClick">
                        <span>{{ menu.label }}</span>
                        <img v-if="menu.img" :src="menu.img">
                        <img v-if="menu.img" :src="menu.img">
                      </li>
                    </router-link>
                  </template>
                </ul>
              </div>

              <!-- Submenu Column 2 -->
              <div v-if="nextSlicedItems.length > 0" class="subsubmenu" :class="{ 'open': isManageMenuOpen } ">
                <ul>
                  <template v-for="(menu, index) in nextSlicedItems">
                    <router-link v-if="!menu.disable" :key="index" :to="menu.url">
                      <li v-if="!menu.disable" :key="index" class="link" :class="{ 'selected-menu': currentRoute.startsWith(menu.url) }" @click="handleSubLinkClick">
                        <span>{{ menu.label }}</span>
                        <img v-if="menu.img" :src="menu.img">
                        <img v-if="menu.img" :src="menu.img">
                      </li>
                    </router-link>
                  </template>
                </ul>
              </div>
            </div>
        </div>
      </nav>
      <AppDialog v-if="enableVirtualMeeting" class="virtual-meeting-url" @closed="isCopied = false" :hideFooter="true">
        <template #header>Virtual Meeting URL</template>
        <div slot="body">
          <p>Click on the URL to copy: <strong>{{ isCopied ? 'Copied!' : '' }}</strong></p>
          <div @click="copyUrl" class="jitsi-url">
            <input id="url" :value="jitsiUrl" readonly>
          </div>
        </div>
      </AppDialog>
      <AlertPopup
        v-if="isClosePopupVisible"
        :showModal="isClosePopupVisible"
        :title="noAccessDashboardAccessContent.title"
        :message="noAccessDashboardAccessContent.message"
        :btnText="noAccessDashboardAccessContent.btnText"
        :type="noAccessDashboardAccessContent.type"
        @close="isClosePopupVisible = false"
      />
    </header>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-facing-decorator'
import { inject } from 'inversify-props'
import { HeaderItem } from '@core/model/structure/HeaderStructure'
import { cid, container } from 'inversify-props'
import { IProjectSettings } from '@master/config/IProjectSettings'
import VideocamIcon from '@core/components/header/assets/videocam.svg'
import hamburgerIcon from '@core/assets/svg/hamburger.svg'
import AppDialog from '@core/components/AppDialog.vue'
import profileIcon from '@core/assets/svg/profile.svg'
import FAQIcon from '@core/assets/svg/faq.svg'
import LogoutIcon from '@core/assets/svg/signout.svg'
import CloseIcon from '@core/assets/svg/cross-close-icon.svg'
import { SharedVariable } from '@core/model/SharedVariable';
import { ability } from '@core/services/CaslAbility'; 
import { isEmpty } from 'lodash/fp'
import arrowRightIcon from '@core/assets/svg/arrow-right.svg'
import { HEADERS } from './TheHeader.vue'
import AlertPopup from '@/views/kyc-form/component/AlertPopup.vue'

interface Dictionary<T> {
  [index: string]: T;
}

@Component({
  components: {
    AppDialog,
    AlertPopup
  }
})
export default class AppDynamicHeader extends Vue {
  @inject()
  private projectSettings: IProjectSettings

  @inject()
  private sharedVariable: SharedVariable;

  @Prop({ required: true }) private readonly header!: HeaderItem[]
  @Prop({ default: [] }) private userAccessViews
  @Prop({ default: [] }) private reportOptions

  // @Prop({ required: true }) private readonly withLogo!: boolean

  @Prop()
  private mini

  private HEADERS = HEADERS
  private hamburgerIcon = hamburgerIcon
  private arrowRightIcon = arrowRightIcon
  private closeIcon = CloseIcon
  private isMenuOpen = false
  private isManageMenuOpen = false
  private isEfnaMenuOpen = false
  private isReportMenuOpen = false
  private jitsiUrl = ''
  private isJitsiUrlShow = false
  private isCopied = false
  private hovering = -1
  private dropDownWidth = 200
  private maxItemsInFirstColumn  = 0
  navigate
  isActive
  private activeIndex = -1
  fileNetURL : string = ''

  isClosePopupVisible = false;
  noAccessDashboardAccessContent = {
    title: `No dashboard access to eFNA`,
    message: `You have not been assigned any view access to the eFNA dashboard. Please contact your system administrator for more details.`,
    btnText: 'Close',
    type: 'warning',
  };

  startVirtualMeeting () {
    this.jitsiUrl = 'https://meet.jit.si/' + this.randomStr(32)
    this.isJitsiUrlShow = true
  }

  randomStr (len: number) {
    const arr = '1234567890abcdefghijklmnopqrstuvwxyz'
    let ans = ''
    for (let i = len; i > 0; i--) {
      ans += arr[Math.floor(Math.random() * arr.length)]
    }
    return ans
  }

  copyUrl () {
    const url: HTMLInputElement = document.getElementById('url') as HTMLInputElement
    url.select()
    url.setSelectionRange(0, 99999)
    document.execCommand('copy')
    this.isCopied = true
  }

  toggleMenu () {
    this.isMenuOpen = !this.isMenuOpen
    this.closeAllExpanded()
  }

  handleLinkClick(index) {
    this.closeAllExpanded()
    this.isMenuOpen = false;
    this.activeIndex = index
  }

  handleSubLinkClick() {
    this.closeAllExpanded()
    this.isMenuOpen = false;
  }

  closeAllExpanded() {
    this.isManageMenuOpen = false
    this.isEfnaMenuOpen = false
    this.isReportMenuOpen = false
  }

  toggleManageDropdown() {
    this.isManageMenuOpen = !this.isManageMenuOpen
    this.isEfnaMenuOpen = false
    this.isReportMenuOpen = false
  }

  openSubMenus(label) {
    if (label === HEADERS.REPORT) {
      if(this.reportOptions.length === 1) {
        this.handleRoute(this.reportOptions[0].href);
        return
      } 
        
      this.isReportMenuOpen = !this.isReportMenuOpen
      this.isEfnaMenuOpen = false
    } 
    
    if (label === HEADERS.EFNA) {
      if (this.userAccessViews.length === 0) {
        this.isClosePopupVisible = true
        return
      } else if (this.userAccessViews.length === 1) {
        this.$router.push({ name: this.userAccessViews[0].href });
        return;
      } 
        
      this.isEfnaMenuOpen = !this.isEfnaMenuOpen
      this.isReportMenuOpen = false
    }

    this.isManageMenuOpen = false
  }

  handleEmptyAreaClick() {
    if(!this.isEfnaMenuOpen && !this.isManageMenuOpen) {
       this.isMenuOpen = false
    }
  }

  // for flipping the dropdown list so that it stays within viewport
  isOutOfView (eleId) {
    const ele = document.getElementById(eleId)
    if (!ele) return false
    const pose = ele.getBoundingClientRect()
    if (document.documentElement.clientWidth - this.dropDownWidth < pose.left) {
      return true
    } else return false
  }

  getHref (routeName: string, params: Dictionary<string>, legacyUrl: string) {
    const { href } = this.$router.resolve({
      name: routeName,
      params
    })

    return this.$router.currentRoute.value.matched.length > 0 ? href : legacyUrl
  }

  handleEfnaRoute(href:string) {
    this.closeAllExpanded()
    if (href) {
      this.$router.push({ name: href })
      this.isMenuOpen = false;
    }
  }

  handleRoute(path) {
     this.isMenuOpen = false;
     this.$router.push(path)
  }

  setActive (index) {
    this.activeIndex = index
  }

  goToHome () {
    this.isMenuOpen = false;
    this.$router.push('/landing-home')
  }

  handleEvent (event) {
    if (event) {
      this.$emit(event)
    }
  }

  canShowMenuForItem(ability, item) {
    if (!item.subjects) return true; // no subject means always show

    const actionsToCheck = ['manage', 'write_all', 'read_all', 'read', 'read_others', 'write'];

    return item.subjects.some(subject =>
      actionsToCheck.some(action => {
        if (!ability.can(action, subject)) return false;
        // Now check if there is a rule with target 'all' or 'others' for this action and subject
        return ability.rules.some(rule =>
          rule.subject === subject &&
          rule.action === action &&
          (rule.target === 'all' || rule.target === 'others')
        );
      })
    );
  }

  calculateMaxItems() {
    const itemHeight = 50; // px
    const headerHeight = 72; // px
    const availableHeight = window.innerHeight - headerHeight;
    this.maxItemsInFirstColumn = Math.floor(availableHeight / itemHeight);
  }

  @Watch('$route')
  beforeRouteEnter(to, from, next) {
    const efnaRoutes = ['/home-manager', '/home-adviser','/home-business-support', '/home-business-assurance', '/home-compliance']
    const clientRoutes = ['/client-info', '/client-list']
    const reportRoutes = ['/report-management', '/exported-reports']

    if(efnaRoutes.includes(to.path)) {
      const efnaMenuIndex = this.header.findIndex(item=>item.label === HEADERS.EFNA)
      this.setActive(efnaMenuIndex) // set Efna menu active
    } else if (clientRoutes.some(path => to.path.startsWith(path))) {
      const clientMenuIndex = this.header.findIndex(item=>item.label === HEADERS.CLIENT)
      this.setActive(clientMenuIndex)
    } else if (reportRoutes.some(path => to.path.startsWith(path))) {
      const reportMenuIndex = this.header.findIndex(item=>item.label === HEADERS.REPORT)
      this.setActive(reportMenuIndex)
    } else if (!this.header.some(item => item.path === to.path)) {
      const manageMenuIndex = this.header.findIndex(item=>item.label === HEADERS.MANAGE)
      this.setActive(manageMenuIndex)// Manage menu selected for all other routes
    }
  }

  get logo () {
    return localStorage.getItem('logo') || this.$store.getters.logoData
  }

  get imageType () {
    return localStorage.getItem('imageType') || this.$store.getters.imageType
  }

  get currentRoute() {
    return this.$route.path
  }

  get activeMenuIndex() {
    const currentPath =  this.$router.currentRoute.value.path

    return this.header.findIndex(item => {
      // Match if the item has a direct path (not '#')
      if (item.path && item.path !== '#' && currentPath.startsWith(item.path)) {
        return true
      }

      if (item?.subPaths?.some(path => currentPath.startsWith(path))) {
        return true
      }

      // Match if it has dropdown items
      if (Array.isArray(item.dropdown)) {
        return item.dropdown.some(subItem => currentPath.startsWith(subItem.href))
      }

      return false
    })
  }

  get enableVirtualMeeting () {
    const { virtualMeeting } = container.get<IProjectSettings>(cid.IProjectSettings)
    return virtualMeeting ? virtualMeeting.enable : false
  }

  get videocamIcon () {
    return VideocamIcon
  }

  get currentUser () {
    return this.$store.getters.currentUser
  }

  get profileOptions () {
    return [
      {
        href: this.getHref('User Profile', { userOid: this.currentUser.oid }, `/user/${this.currentUser.oid}/profile/summary/`),
        icon: profileIcon,
        label: 'Profile'
      },
      {
        href: '/web/api/pdfView/FAQ.pdf',
        icon: FAQIcon,
        target: '_blank',
        label: 'FAQ'
      },
      {
        event: 'logout',
        icon: LogoutIcon,
        label: 'Sign out'
      }
    ]
  }

  get slicedItems() {
		return this.menus.slice(0, this.maxItemsInFirstColumn);
	}

  get nextSlicedItems () {
		return this.menus.slice(this.maxItemsInFirstColumn);
  }

  async mounted() {
    this.calculateMaxItems();;

    if (this.activeMenuIndex !== -1) {
      this.setActive(this.activeMenuIndex)
    }
  }

  get currentAllPermissions() {
    return this.$store.getters.currentAllPermission
  }


  get isTenantConfigDisabled () {
    return this.sharedVariable.isPermissionDisabled("tenantConfiguration", "read", this.currentAllPermissions)
  }

  get isQualificationSetupDisabled () {
    return this.sharedVariable.isPermissionDisabled("qualificationsSetup", "read", this.currentAllPermissions)
  }

  get menus() {
    const menu =  ['adviser', 'supervisor', 'director'].includes(this.currentUser.systemRole) ?
        [
          {
            label: 'Resources',
            url: '/resources',
            // subjects: ['resources'],
            disable: !this.projectSettings.useResourcesModule
          }
        ] : [
          {
            label: 'Adviser Sales Code Update',
            url: '/adviser-sales-code-update',
          },
          {
            label: 'Assumptions List',
            url: '/admin-assumptions',
            disable: !this.projectSettings.useAssumptionsList
          },
          {
            url: '/audit-log',
            label: 'Audit Log',
            component: () => import('@core/pages/auditLog/components/AuditLog.vue'),
            subjects: ['auditLogs']
          },
          {
            url: '/approvals',
            label: 'Approvals',
            component: () => import('@core/pages/approvals/components/Approvals.vue')
          },
          {
            label: 'Balanced Scorecard (BSC) Setup',
            url: '/bsc-setup',
            subjects: [
              'bscAdviserGrade',
              'bscReportSetup',
              'bscSupervisorGrade',
              'bscVariablePercentage',
            ],
          },
          {
            label: 'Balanced Scorecard (BSC) Grading',
            url: '/bsc-grading/',
            subjects: [
              'bscAgentFinding',
              'bscBaseRecord',
              'bscCycleExecution',
              'bscGradeImportSummary',
              'bscAdviserProfile',
              'bscSupervisorVarIncome',
              'bscAdviserVarIncome',
              'bscAdversePolicy'
            ],
          },
          {
            label: 'Branch and Manager Administration',
            url: '/group-list',
            // img: require('@core/assets/admin/Group Administration.png')
          },
          {
            url: '/commission/',
            label: 'Commissions',
            img: ''
          },
          {
            label: 'Compensation & Production Bonus Setup',
            url: '/compensation-setup',
            // img: require('@core/assets/admin/Product Principal List.png')
          },
          {
            label: 'Continuing Professional Development(CPD)',
            url: '/cpd/summary',
            subjects: ['cpdTraining'],
            // img: require('@core/assets/admin/CPD.png')
          },
          {
            label: 'Country Master',
            url: '/country-master',
            disable: ''
          },
          {
            label: 'Data Load',
            url: '/data-load',
            subjects: ['dataLoad']
          },
          {
            label: 'DiSign',
            url: '/disign-panel',
            img: '',
            disable: ''
          },
          {
            label: 'Designation List',
            url: '/designation-list',
            img: '',
            disable: ''
          },
          {
            label: 'FileNet',
            url: this.fileNetURL || '',
            img: require('@core/assets/admin/externalLink_Line.svg'),
            disable: isEmpty(this.fileNetURL)
          },
          {
            label: 'Intermediaries',
            url: '/payee-list',
          },
          {
            label: 'New Business Registry',
            url: '/policy-list',
            img: ''
          },
          {
            label: 'Product Master',
            url: '/admin-products',
          },
          {
            label: 'Product Provider',
            url: '/company-codes-list',
          },
          // {
          //   label: 'Recruit',
          //   url: '/home-recruiter',
          //   img: ''
          // },
          {
            label: 'Qualification Setup',
            url: '/qualification-setup',
            img:'',
            disable: this.isQualificationSetupDisabled 
          },
          {
            label: 'Resources',
            url: '/resources',
            // img: require('@core/assets/admin/Resources.png'),
            disable: !this.projectSettings.useResourcesModule
          },
          {
            label: 'Scheduler',
            url: '/scheduler',
            subjects: ['scheduler']
            // img: require('@core/assets/admin/Intermediaries List.png')
          },
          {
            label: 'System Rights Administration',
            url: '/system-rights-administration',
            img: '',
            disable: this.currentUser.systemRole !== 'it-super-admin'
          },
          {
            label: 'User Administration',
            url: '/user-list',
            img:''
          },
          {
            label: 'Tenant Configuration',
            url: '/tenant-configuration',
            img:'',
            disable: this.isTenantConfigDisabled
          }
        ]
    const filteredMenu = menu.filter(item => this.canShowMenuForItem(ability, item));
    return filteredMenu
  }

  
}
</script>

<style lang="scss" scoped>

@import '@/design';

header {
  height: $header-height;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 999;
  transition: all 0.5s ease;

  &.mini {
    padding: 0rem 2rem;
    display: flex;
    justify-content: flex-start;

    .logo-wrapper {
      height: 64px;
      max-width: 170px;
      padding: 0.25rem;
      transition: all 0.5s ease;
      margin-bottom: 16px;

      .logo {
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center left;
        height: 100%;
        width: 100%;
        object-fit: contain;

        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}

.sidebar-wrapper {
  display: flex;
  position: absolute;
  top: 72px;
  height: calc(100% - 72px);
  width: 397.333px;
  z-index: 999;
  border-top: 1px solid #ddd;
  left: -397.333px;
  transition: left 0.5s ease;

  &.open {
    left: 0;
    width: 100%;
  }
}

.sidebar {
  background: white;
  width: 397.333px;
  max-width: 397.33px;
  padding-top: 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #ddd;

  ul {
    list-style: none;
    padding: 20px;

    a{
      display: flex;
      text-decoration: none;
      gap: 16px;
      align-items: center;
      color: $form-font;

      &:hover {
        color: $color-primary;
        font-weight: 600;
      }
    }
  }

  li {
    display: flex;
    padding: 12px 0;
    font-size: 16px;
    list-style: none;
    align-items: center;
    gap: 16px;
    cursor: pointer;
    text-align: left;

    .menu-item-svg {
      margin-top: 5px;
    }

    .menu-item-svg svg path {
      stroke: #707070;
    }

    div {
      display: flex;
      text-decoration: none;
      gap: 16px;
      align-items: center;
      width: 220px;

      .active-icon {
        margin-left: -2px;
        margin-top: 5px;
      }

      &:hover {
        color: $color-primary;
        font-weight: 600;

        .menu-item-svg svg path {
          stroke: $color-primary;
        }
      }
    }
  }

  .user-detail {
    display: flex;
    align-items: center;
    background-color: #434343;
    padding: 16px 24px;
    color: #fff;
  }
}

.menu-bottom {
  margin-top: auto;

  li:hover a{
    color: $color-primary !important;
    font-weight: 600;
  }
}

.bottom-label {
  padding-top: 8px;
  font-size: 14px;
  color: #555;
}

.submenu-wrapper {
  display: flex;
  flex-grow: 1;
  overflow-x: auto;
  width: 100%;
}

.submenu,
.subsubmenu {
  width: 50%;
  background: white;
  border-right: 1px solid #ddd;
  display: none;

  &.open {
    display: block;
  }

  a {
    font-size: 16px;
    text-decoration: none;
    color: $form-font;
  }

  ul {
    margin-left: 0;
  }

  li {
    padding: 16px 24px;
    list-style: none;
    text-align: left;

    &:hover {
      color: $color-primary;
      font-weight: 600;
    }

    .active {
      border-left: 1px solid $color-primary;
    }
  }
}

.active {
  font-weight: bold;
  position: relative;
  color: $color-primary;
}

.selected-menu {
  background-color: #EAEAEA;
  border-left: 4px solid $color-primary;

  span {
    font-weight: 600 !important;
    color: $color-primary;
  }
}

.action-wrapper {
  width: 24px;
  height: 24px;
  margin-right: 24px;
  margin-bottom: 16px;

  .close-icon svg{
    width: 18px;
    height: 18px;
  }
}

:deep(.link:hover svg path) {
  stroke: $color-primary;
}

:deep(.menu-bottom li:hover svg path) {
  stroke: $color-primary;
}
</style>
